<template>
    <header v-if="isHeaderVisible" class="header"
        :class="{ 'header-scrolled': isScrolled, 'full-width': !isNavBarVisible }">
        <div class="header-inner">
            <div class="header-content">
                <div class="header-left">
                    <image-button v-if="!isNavBarVisible" :src="BarIcon" :hint="'Показать меню'" @click="toggleNavBar"
                        class="menu-btn" />
                    <h2 class="header-title">{{ title }}</h2>
                </div>
                <div class="header-controls">
                    <div class="header-controls__search">
                        <v-input class="header-controls__search-input" :inputs="searchInput"></v-input>
                        <image-button class="header-controls__search-btn" :src="SearchIcon" :hint="'Поиск'" />
                    </div>
                    <v-dropdown :items="[]" :customContent="true">
                        <template #trigger>
                            <div class="user-profile">
                                <!-- Placeholder for user avatar or other controls -->
                                <div class="avatar-placeholder">
                                    <simple-svg :src="UserIcon" custom-class-name="avatar-icon"></simple-svg>
                                </div>
                            </div>
                        </template>
                        <template #content>
                            <user-profile-menu />
                        </template>
                    </v-dropdown>
                    <div class="ai-assistant" @click="toggleAiChat" v-if="myUserInfo?.llmEnabled">
                        <div class="ai-placeholder">
                            <simple-svg :src="StarsIcon" custom-class-name="ai-icon"></simple-svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { useNavigationStore } from '@/store/NavigationStore';
import { useChatStore } from '@/store/ChatStore';
import { useThemeStore } from '@/store/ThemeStore';
import { useUserStore } from '@/store/UserStore';
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import BarIcon from '@/assets/icons/Bar_Left.svg';
import SearchIcon from '@/assets/icons/Search_Magnifying_Glass.svg';
import VDropdown from '@/components/ui/VDropdown.vue';
import UserProfileMenu from '@/components/layout/UserProfileMenu.vue';
import { useAuthStore } from '@/store/AuthStore';
import UserIcon from '@/assets/icons/User_02.svg';
import StarsIcon from '@/assets/icons/Stars.svg';

export default {
    name: 'VHeader',
    components: {
        VDropdown,
        UserProfileMenu
    },
    data() {
        return {
            UserIcon,
            StarsIcon
        }
    },
    methods: {
    },
    setup() {
        const userStore = useUserStore();
        const navigationStore = useNavigationStore();
        const chatStore = useChatStore();
        const authStore = useAuthStore();
        const themeStore = useThemeStore();

        const route = useRoute();
        const windowWidth = ref(window.innerWidth);
        const onResize = () => { windowWidth.value = window.innerWidth; };

        const isScrolled = ref(false);
        const isNavBarVisible = computed(() => navigationStore.isNavBarVisible);
        const isHeaderVisible = computed(() => {
            if (route.name === 'chat' && windowWidth.value < 768 && chatStore.activeChat) return false;
            return navigationStore.isHeaderVisible;
        });
        const myUserInfo = computed(() => userStore.myUserInfo);

        const title = computed(() => {
            const activeTab = navigationStore.tabs.find(tab => tab.active);
            return activeTab ? activeTab.text : '';
        });

        const searchInput = ref([{
            id: 'search',
            name: 'Поиск...',
            placeholder: 'Поиск...',
            value: '',
            type: 'text'
        }]);

        const handleScroll = () => {
            isScrolled.value = window.scrollY > 10;
        };

        const toggleNavBar = () => {
            navigationStore.toggleNavBar();
            
        };

        onMounted(() => {
            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', onResize);
        });

        onUnmounted(() => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', onResize);
        });

        const toggleAiChat = () => {
            navigationStore.toggleAiChat();
        };

        return {
            title,
            isScrolled,
            searchInput,
            isNavBarVisible,
            toggleNavBar,
            toggleAiChat,
            isHeaderVisible,
            BarIcon,
            SearchIcon,
            authStore,
            themeStore,
            myUserInfo
        };
    }
}
</script>

<style lang="scss">
.header {
    position: sticky;
    top: 0;
    z-index: 100;
    // background-color: var(--color-bg-dark);
    transition: box-shadow 0.3s ease;
    padding: 10px;
    // padding-top: 20px;
}

.header-inner {
    box-sizing: border-box;
    background-color: var(--color-bg);
    width: 100%;
    border-radius: 10px;
    padding: 10px 20px;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // max-width: 1200px;
    margin: 0 auto;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 16px;
}

.header-title {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
}

.header-controls {
    display: flex;
    align-items: center;
    gap: 20px;

    &__search {
        height: 29px;

        .button-image {
            display: none;
        }

        @media (max-width: 768px) {

            .v-input {
                display: none;
            }

            .button-image {
                display: block;
            }
        }
    }
}

.avatar-placeholder {
    width: 32px;
    height: 32px;
    background-color: var(--color-bg-light);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    .avatar-icon {

        path {
            stroke: var(--color-btn-text);
        }
    }
}

.ai-placeholder {
    width: 32px;
    height: 32px;
    background-color: var(--color-blue);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-btn-text);
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;

    .ai-icon {
        path {
            fill: var(--color-btn-text);
        }
    }
}
</style>
